import { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Link from '@mui/material/Link';
import { includes, values } from 'ramda';
import { useDispatch } from 'react-redux';

import ComponentLoader from 'components/molecules/ComponentLoader';
import { EMPTY_VALUES } from 'constants/general';
import fetch from 'features/common/fetch';

export const PKUrl = (props) => {
	const dispatch = useDispatch();

	const { doNotPreloadIascLink, fetchArgs, url, muiLink = false } = props;

	const [clickUrl, setClickUrl] = useState(EMPTY_VALUES.STRING);
	const [isLoading, setIsLoading] = useState(undefined);

	useEffect(() => {
		if (!doNotPreloadIascLink) {
			getUrl(false);
		}
		//eslint-disable-next-line
	}, []);

	const prevProps = useRef();
	useEffect(() => {
		if (prevProps.current !== fetchArgs) {
			if (!doNotPreloadIascLink) {
				getUrl(false);
			}
		}
		prevProps.current = fetchArgs;
		// eslint-disable-next-line
	}, [fetchArgs, doNotPreloadIascLink]);

	const getUrl = useCallback(
		(openAfterLoad) => {
			if (!includes(undefined, values(fetchArgs))) {
				setIsLoading(true);

				let win;
				if (openAfterLoad) {
					win = window.open();
				}

				return dispatch(fetch.actions.get(url, { queryParams: fetchArgs }))
					.then((response) => {
						const { iascRedirectUrl } = response.body;
						if (openAfterLoad) {
							win.location.href = iascRedirectUrl;
						} else {
							setClickUrl(iascRedirectUrl);
						}
						setIsLoading(false);
					})
					.catch(() => {
						setIsLoading(false);
					});
			}
		},
		[dispatch, fetchArgs, url],
	);

	// Every url can be opened only once, after user clicks on link we have to generate new one
	const handleLinkClick = useCallback(
		(event) => {
			event.stopPropagation();
			getUrl(doNotPreloadIascLink);
		},
		[doNotPreloadIascLink, getUrl],
	);

	return (
		<ComponentLoader isLoading={isLoading}>
			{muiLink ? (
				<Link
					underline="none"
					onClick={handleLinkClick}
					sx={{
						cursor: 'pointer',
						color: 'primary.main',
					}}
					href={doNotPreloadIascLink ? undefined : clickUrl}
				>
					{props.children}
				</Link>
			) : (
				<a
					target="_blank"
					rel="noopener noreferrer"
					href={doNotPreloadIascLink ? undefined : clickUrl}
					onClick={handleLinkClick}
					className="Link"
				>
					{props.children}
				</a>
			)}
		</ComponentLoader>
	);
};

PKUrl.propTypes = {
	children: PropTypes.node,
	doNotPreloadIascLink: PropTypes.bool,
	fetchArgs: PropTypes.object,
	get: PropTypes.func,
	muiLink: PropTypes.bool,
	url: PropTypes.string,
};

export default PKUrl;
